type NavigatorWithUserAgentData = Navigator & {userAgentData?: {mobile?: boolean}};

export function isMobileDevice(): boolean {
	if (typeof navigator === 'undefined') return false;
	const {userAgentData, userAgent, maxTouchPoints} = navigator as NavigatorWithUserAgentData;
	if (userAgentData?.mobile) return true;
	if (/Android|iPhone|iPad|iPod/i.test(userAgent)) return true;
	// iPadOS с настройками по умолчанию представляется настольным Safari на Mac
	return /Macintosh/.test(userAgent) && maxTouchPoints > 1;
}
